// Styles
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Vuetify
import { createVuetify, type ThemeDefinition } from 'vuetify';

const gvmTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: '#0746a6',
    secondary: '#248F99',
    accent: '#474a56',
    error: '#de350a',
    info: '#0b0b0d',
    warning: '#FFC107',
    selected: '#0052CC',
    'custom-yellow': '#FFC400',
    'light-green': '#dfd',
    'background-white': '#fff',
    'background-light': '#f4f5f7',
    'background-medium': '#e6e6e6',
    'background-dark': '#565e6a',
    'blue-text': '#172B4D',
    'primary-light': '#7bc6ff',
    success: '#00875a',
  },
};

export default createVuetify(
  {
    components,
    directives,
    theme: {
      defaultTheme: 'gvmTheme',
      themes: {
        gvmTheme,
      },
    },
    defaults: {
      VBtn: {
        color: 'primary',
      },
      VCheckbox: {
        color: 'primary',
      },
      VSwitch: {
        color: 'primary',
        inset: true,
        density: 'compact',
      },
      VRadioGroup: {
        color: 'primary',
        hideDetails: 'auto',
      },
      VAlert: {
        variant: 'outlined',
        color: 'primary',
        type: 'info',
        border: 'bottom',
        elevation: '1',
      },
    },
  },
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
);
